import DashboardDetails from './DashboardDetails';

export default DashboardDetails;
